export function useGetClientTagFromSubdomain() {
  const getClientTagFromSubdomain = () => {
    const config = useRuntimeConfig()
    const receiptDomain = config.public.receiptDomain
    const host = window.location.hostname

    if (!host.endsWith(receiptDomain) && !host.endsWith(`.${receiptDomain}`)) {
      return null
    }

    const deepestSubdomain = host.replace(`.${receiptDomain}`, '')
    if (deepestSubdomain && deepestSubdomain !== 'www' && deepestSubdomain !== receiptDomain) {
      return deepestSubdomain
    }
    return null
  }

  return {
    getClientTagFromSubdomain,
  }
}
